// Form state <-> API request conversion for the admin package form.

export const categories = ['Group', 'Family', 'Customized'];

export const categoryInfo = {
  Group: {
    label: 'Group tour',
    plural: 'Group tours',
    blurb: 'Fixed departure dates with a tour manager. Customers book seats on a departure.',
    priceLabel: 'Price per adult (twin sharing)',
  },
  Family: {
    label: 'Family package',
    plural: 'Family packages',
    blurb: 'Fixed-price holiday that customers book for any travel date they choose.',
    priceLabel: 'Price per adult (twin sharing)',
  },
  Customized: {
    label: 'Customized package',
    plural: 'Customized packages',
    blurb: 'Sample itinerary with a starting price. Customers send an enquiry and your team builds the quote.',
    priceLabel: 'Starting price per adult',
  },
};

export const emptyDay = () => ({ title: '', meals: '', description: '' });
export const emptyDeparture = () => ({ date: '', seats: '', pricePerAdult: '' });

export const emptyForm = (category = 'Family') => ({
  category: categories.includes(category) ? category : 'Family',
  title: '',
  destination: '',
  isInternational: false,
  theme: 'Family',
  nights: 4,
  pricePerAdult: '',
  childPrice: '',
  originalPrice: '',
  imageUrl: '',
  overview: '',
  cities: '',
  hotels: '',
  highlights: '',
  inclusions: '',
  exclusions: '',
  customizationOptions: '',
  itinerary: [emptyDay()],
  departures: [emptyDeparture()],
  minGroupSize: '',
  maxGroupSize: '',
  tourManagerIncluded: true,
  isPublished: false,
});

const text = (v) => (v == null ? '' : String(v));
const lines = (list) => (list || []).join('\n');

export function toForm(p) {
  return {
    category: p.category,
    title: p.title,
    destination: p.destination,
    isInternational: p.isInternational,
    theme: p.theme || 'Family',
    nights: p.nights,
    pricePerAdult: text(p.pricePerAdult),
    childPrice: text(p.childPrice),
    originalPrice: text(p.originalPrice),
    imageUrl: text(p.imageUrl),
    overview: text(p.overview),
    cities: lines(p.cities),
    hotels: lines(p.hotels),
    highlights: lines(p.highlights),
    inclusions: lines(p.inclusions),
    exclusions: lines(p.exclusions),
    customizationOptions: lines(p.customizationOptions),
    itinerary: p.itinerary.length
      ? p.itinerary.map((d) => ({ title: d.title, meals: text(d.meals), description: text(d.description) }))
      : [emptyDay()],
    departures: p.departures.length
      ? p.departures.map((d) => ({ date: d.date, seats: text(d.seats), pricePerAdult: text(d.pricePerAdult) }))
      : [emptyDeparture()],
    minGroupSize: text(p.minGroupSize),
    maxGroupSize: text(p.maxGroupSize),
    tourManagerIncluded: p.tourManagerIncluded,
    isPublished: p.isPublished,
  };
}

const list = (value) => value.split('\n').map((s) => s.trim()).filter(Boolean);
const num = (value) => (String(value).trim() === '' ? null : Number(value));

export function toRequest(f) {
  const isGroup = f.category === 'Group';
  return {
    category: f.category,
    title: f.title.trim(),
    destination: f.destination.trim(),
    isInternational: f.isInternational,
    theme: isGroup ? null : f.theme,
    nights: Number(f.nights),
    pricePerAdult: Number(f.pricePerAdult),
    childPrice: num(f.childPrice),
    originalPrice: num(f.originalPrice),
    imageUrl: f.imageUrl.trim() || null,
    overview: f.overview.trim() || null,
    cities: list(f.cities),
    hotels: list(f.hotels),
    highlights: list(f.highlights),
    inclusions: list(f.inclusions),
    exclusions: list(f.exclusions),
    customizationOptions: f.category === 'Customized' ? list(f.customizationOptions) : [],
    itinerary: f.itinerary
      .filter((d) => d.title.trim())
      .map((d) => ({ title: d.title.trim(), meals: d.meals.trim() || null, description: d.description.trim() || null })),
    departures: isGroup
      ? f.departures.filter((d) => d.date).map((d) => ({ date: d.date, seats: Number(d.seats), pricePerAdult: num(d.pricePerAdult) }))
      : [],
    minGroupSize: isGroup ? num(f.minGroupSize) : null,
    maxGroupSize: isGroup ? num(f.maxGroupSize) : null,
    tourManagerIncluded: isGroup && f.tourManagerIncluded,
    isPublished: f.isPublished,
  };
}
